module.exports = __webpack_public_path__ + "img/year-in-review.2d9864a3.png";